/** Shared palette for Template 2 (cover + confidentiality + financial offer). */
export const T3 = {
  /** Primary brand color — also the default when `configs.theme.color` is unset. */
  brandBlue: "#1F3A5F",
  /** Accent used for stripes, underlines and secondary titles. */
  accentBlue: "#2E6FB7",
  /** Light tint used for hero / card backgrounds. */
  softBlue: "#EAF1F8",
  /** Deep red for section titles and the "Restricted" status. */
  restrictedRed: "#C00000",
  /** Hairline borders on inner pages / cards. */
  borderGray: "#D9DEE7",
  /** Body copy. */
  textGray: "#3F4A5A",
  /** Labels & muted meta. */
  mutedGray: "#8A94A6",
};

export const DEFAULT_COMPANY_NAME = "Company";
export const DEFAULT_SUBJECT = "Quotation";
/** Shown when the quotation has no `quotation_title` — cover + inner page headers. */
export const DEFAULT_OFFER_TITLE = "Quotation Title";

/** Default heading over the items/price table (page 3). */
export const DEFAULT_ITEMS_DIVIDER = "Financial Offer";

export const CONFIDENTIALITY_PARENT = "Confidentiality, Copyright and reproduction: ";
export const CONFIDENTIALITY_STATUS = "Restricted";
